





































import { DatacollectDto } from '@/services/datacollect';
import { Vue, Component, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class DatacollectForm4 extends Vue {
  @PropSync('formData') syncFormData!: DatacollectDto;

  spinning: boolean = false;
  dragField: any = {};

  @Watch('syncFormData.syncConfig', { immediate: false, deep: true })
  onFieldListChange() {
  }

  mounted() {
  }
  
  sameNameMapping() {
    this.syncFormData.syncConfig && this.syncFormData.syncConfig.forEach((v: any, index: number) => {
      let item = this.syncFormData.sourceDsColumns && this.syncFormData.sourceDsColumns.find((f: any) => f.columnNameEn === v.sinkColumnNameEn);
      if (item) {
        v.sourceColumnNameEn = item.columnNameEn;
        v.sourceColumnNameCn = item.columnNameCn;
      }
    });
    this.$forceUpdate();
  }

  allowDrop(e: any) {
    e.preventDefault();
  }

  dragstart(dragField: any) {
    this.dragField = dragField;
  }

  drop(index: number) {
    if (this.syncFormData.syncConfig) {
      this.syncFormData.syncConfig[index].sourceColumnNameEn = this.dragField.columnNameEn;
      this.syncFormData.syncConfig[index].sourceColumnNameCn = this.dragField.sourceColumnNameCn;
    }

    this.$forceUpdate();
  }

  removeField(index: number) {
    if (this.syncFormData.syncConfig) {
      this.syncFormData.syncConfig[index].sourceColumnNameEn = '';
      this.syncFormData.syncConfig[index].sourceColumnNameCn = '';
    }
    this.$forceUpdate();
  }
}
